/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddAppointmentConfigDto { 
    /**
     * Tipo dell\'evento
     */
    kind: string;
    /**
     * Valore della durata
     */
    value: number;
    /**
     * Unità di misura: minuti, ore o giorni
     */
    unit: AddAppointmentConfigDto.UnitEnum;
    /**
     * Appuntamento multiplo con molti utenti e/o candidati
     */
    multiple: boolean;
    /**
     * Appuntamento con notifica
     */
    withNotification: boolean;
    /**
     * Appuntamento con localita fisica
     */
    withAddress: boolean;
}
export namespace AddAppointmentConfigDto {
    export const UnitEnum = {
        Seconds: 'seconds',
        Minutes: 'minutes',
        Hours: 'hours',
        Days: 'days',
        Weeks: 'weeks',
        Months: 'months',
        Years: 'years'
    } as const;
    export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];
}


